import { render, staticRenderFns } from "./shopActivity.vue?vue&type=template&id=f886df58&scoped=true&"
import script from "./shopActivity.vue?vue&type=script&lang=js&"
export * from "./shopActivity.vue?vue&type=script&lang=js&"
import style0 from "./shopActivity.vue?vue&type=style&index=0&id=f886df58&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f886df58",
  null
  
)

export default component.exports